import React, { useRef, useState, useEffect } from 'react';
import { SxProps, Tooltip, Typography } from '@mui/material';
import { styles } from './TextOverflowWithTooltip.styles';

interface TextOverflowWithTooltipProps {
  children: React.ReactNode;
  sx?: SxProps;
}

const TextOverflowWithTooltip: React.FC<TextOverflowWithTooltipProps> = ({ children, sx, ...props }) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setShowTooltip(el.scrollWidth > el.clientWidth);
    }
  }, [children]);

  return (
    <Tooltip title={showTooltip ? children : ''} disableHoverListener={!showTooltip}>
      <Typography component="span" ref={textRef} style={styles.ellipsisTooltip} sx={sx} {...props}>
        {children}
      </Typography>
    </Tooltip>
  );
};

export default TextOverflowWithTooltip;
